import React from 'react';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions'  
import { Button } from 'reactstrap';

const SignedInLinks = (props) => {
    return (
        <Button outline color="secondary" onClick={(e) => props.signOut(props.uid)}>Log Out</Button>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: (uid) => dispatch(signOut(uid))
    }
}


export default connect(null, mapDispatchToProps)(SignedInLinks);